module.exports = __webpack_public_path__ + "static/media/teal-faces.d814aebf.png";